import {createFetcher} from "./foundations/fetcher";

export const fetch = createFetcher(process.env.NEXT_PUBLIC_MONOLITH_URI + "/hib");
